import Toash from "./components/toash";

class Anchor {
  constructor() {
    this.anchorEls = document.querySelectorAll(".jsAnchor");
    this.top = 80;
    this.init();
  }

  init() {
    if (this.anchorEls.length > 0) {
      this.anchorEls.forEach((anchorEl) => {
        anchorEl.addEventListener(
          "click",
          this.anchorClick.bind(this, anchorEl)
        );
      });
    }
    this.hash = window.location.hash;
    if (this.hash) {
      let anchorTargetEl = document.getElementById(this.hash.replace("#", ""));
      this.move(anchorTargetEl, "init");
    }
  }

  move(el, state) {
    if (state === "init") {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0
      );
    }
    $("html, body").animate(
      {
        scrollTop: el.offsetTop - this.top,
      },
      500
    );
  }

  anchorClick(el, e) {
    let anchorTargetEl = document.getElementById(el.dataset.anchor);
    if (anchorTargetEl) {
      this.move(anchorTargetEl, "click");
      e.preventDefault();
    }
  }
}

class Expand {
  constructor() {
    this.els = document.querySelectorAll('.jsExpand');
    this.els.forEach(el => {
      el.addEventListener("click", this.click.bind(this, el));
    });
  }
  
  click(el, e) {
    console.log(el, e);
    el.classList.toggle('expand');
  }
}

class SendEmail {
  constructor() {
    this.btnSubmitEl = document.getElementById("jsSubmit");
    this.nameEl = document.getElementById("jsName");
    this.telEl = document.getElementById("jsTel");
    this.emailEl = document.getElementById("jsEmail");
    this.msgEl = document.getElementById("jsMsg");
    this.txtEl = document.getElementById("jsTxt");
    this.regexEmail =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.toash = new Toash("jsToash");
    this.init();
  }

  init() {
    if (this.btnSubmitEl) {
      this.btnSubmitEl.addEventListener("click", (e) => {
        this.txtEl.innerHTML = "";
        const token = turnstile.getResponse();
        if (
          this.nameEl.value === "" ||
          this.emailEl.value === "" ||
          this.telEl.value === "" ||
          this.msgEl.value === ""
        ) {
          this.toash.show("Vui lòng điền đầy đủ thông tin!", "error");
        } else if (!this.emailEl.value.match(this.regexEmail)) {
          this.toash.show("Email không đúng định dạng!", "error");
        }else if (!token) {
          this.toash.show("Vui lòng xác thực captcha!", "error");
        } else {
          this.btnSubmitEl.dataset.state = "sending";
          this.send(token);
        }
        e.preventDefault();
      });
    }
  }

  send(token) {
    let url = "https://hemail.htemplate.com/Email/send",
    data = {
      name: this.nameEl.value,
      tel: this.telEl.value,
      email: this.emailEl.value,
      msg: this.msgEl.value,
      website: location.hostname,
      to: "congvt18@fpt.com",
      token: token
    },
    options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(url, options)
      .then(async (res) => {
        const result = await res.json();
        if (!res.ok) {
          throw result;
        }
        if (result.response === "1") {
          this.nameEl.value = "";
          this.emailEl.value = "";
          this.msgEl.value = "";
          this.telEl.value = "";
          this.toash.show("Gửi email thành công!", "success");
          this.txtEl.innerHTML = "Cảm ơn bạn đã gửi liên hệ<br>Chúng tôi sẽ liên hệ bạn trong thời gian sớm nhất!";
          this.btnSubmitEl.dataset.state = "success";
          turnstile.reset();
        } else {
          throw result;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        let message = "Gửi thất bại, vui lòng thử lại!";
        if (error?.response === "captcha_error") {
          message = "Xác thực captcha thất bại!";
          turnstile.reset();
        }

        this.toash.show(message, "error");
        this.btnSubmitEl.dataset.state = "error";
      });
  }
}

window.addEventListener("load", (e) => {
  new Anchor();
  new SendEmail();
  new Expand();

  
  const services = [
    'đặt dịch vụ internet',
    'liên hệ tư vấn',
    'đăng ký lắp đặt camera',
    'đăng ký gói Combo Sky',
    'đăng ký Internet Sky',
    'yêu cầu hỗ trợ kỹ thuật',
  ];

  const surnames = ['Nguyễn', 'Trần', 'Lê', 'Phạm', 'Võ', 'Hoàng', 'Phan', 'Tô', 'Huỳnh', 'Bùi'];

  const maleMiddleNames = ['Văn', 'Minh', 'Đức', 'Quốc', 'Thanh', 'Hoàng', 'Hữu', 'Gia', 'Trọng', 'Công', 'Quang', 'Tuấn', 'Hòa'];

  const maleFirstNames = ['An', 'Hùng', 'Tuấn', 'Bảo', 'Nam', 'Phúc', 'Huy', 'Nghĩa', 'Vinh', 'Danh', 'Phong', 'Phú', 'Đức', 'Trung', 'Sơn', 'Hải', 'Lộc', 'Hưng', 'Lý', 'Thắng', 'Trí', 'Duy', 'Đạt', 'Sang', 'Vũ', 'Tài', 'Long', 'Thịnh', 'Tùng', 'Phát', 'Khải', 'Tấn'];

  const femaleMiddleNames = ['Thị', 'Ngọc', 'Thúy', 'Hương', 'Tâm', 'Hồng', 'Yến', 'Anh', 'Chi', 'Duyên'];

  const femaleFirstNames = ['Ngọc', 'Hồng', 'Thanh', 'Thu', 'Mai', 'Phương', 'Bích', 'Kim', 'Trâm', 'Yến', 'Lan', 'Hạnh', 'Thảo', 'Ngân', 'Vân', 'Trang', 'Ánh', 'Diễm', 'Tuyết', 'Nhung', 'Hương', 'Oanh', 'Duyên', 'Nguyệt', 'Tâm', 'Khánh', 'Quỳnh', 'Hà', 'Vy', 'My', 'Hoa', 'Liên', 'Thủy', 'Giang', 'Cẩm', 'Huyền', 'Nhã', 'Thúy', 'Bảo', 'Tuyến', 'Hương'];

  function generateRandomName() {
    const isMale = Math.random() > 0.5;
    const prefix = isMale ? 'Anh' : 'Chị';
    const surname = surnames[Math.floor(Math.random() * surnames.length)];
    const middleName = isMale
      ? maleMiddleNames[Math.floor(Math.random() * maleMiddleNames.length)]
      : femaleMiddleNames[Math.floor(Math.random() * femaleMiddleNames.length)];
    const firstName = isMale
      ? maleFirstNames[Math.floor(Math.random() * maleFirstNames.length)]
      : femaleFirstNames[Math.floor(Math.random() * femaleFirstNames.length)];

    return `${prefix} ${surname} ${middleName} ${firstName}`;
  }

  function generatePhone() {
    const phone = Math.floor(1000 + Math.random() * 9000).toString();
    return `0${phone}xxxxx`;
  }

  function generateTime() {
    const time = Math.floor((Math.random() * 15) + 3).toString();
    return `${time} phút trước`;
  }

  function getRandomService() {
    return services[Math.floor(Math.random() * services.length)];
  }

  function randomArr(size) {
    let arr = [];
    for (let i = 0; i < size; i++) {
      arr.push({
        name: generateRandomName(),
        phone: generatePhone(),
        service: getRandomService(),
        time: generateTime(),
      });
    }
    return arr;
  }

  const notificationEl = document.querySelector('.jsNotification');
  const notificationNamelEl = document.querySelector('.jsNotificationName');
  const notificationTelEl = document.querySelector('.jsNotificationTel');
  const notificationTxtEl = document.querySelector('.jsNotificationTxt');

  if (notificationEl) {
    let arr = randomArr(10000),
      index = 0;

    setInterval(() => {
      notificationNamelEl.textContent = `${arr[index].name}`;
      notificationTelEl.textContent = `Số điện thoại (0${arr[index].phone})`;
      notificationTxtEl.textContent = `Vừa ${arr[index].service} ${arr[index].time}`;
      index++;

      setTimeout(() => {
        notificationEl.classList.add('current');
      }, 100);

      setTimeout(() => {
        notificationEl.classList.remove('current');
      }, 10000);
    }, 15000);
  }

  
  const particlesEl = document.getElementById('jsParticles');

  if (particlesEl) {
    particlesJS("jsParticles", {
      "particles": {
        "number": {
          "value": 100,
          "density": {
            "enable": true,
            "value_area": 800
          }
        },
        "color": {
          "value": "#ffffff"
        },
        "shape": {
          "type": ["image", "image1"],
          "stroke": {
            "width": 0,
            "color":
              "#000000"
          },
          "polygon": {
            "nb_sides": 5
          },
          "image": {
            "src": ["../assets/img/icon/i-wifi.webp", "../assets/img/icon/i-camera1.webp", "../assets/img/icon/i-camera2.webp"],
            "width": 60,
            "height": 55
          }
        },
        "opacity": {
          "value": 0.5,
          "random": false,
          "anim": {
            "enable": false,
            "speed": 1,
            "opacity_min": 0.1,
            "sync": false
          }
        },
        "size": {
          "value": 10,
          "random": true,
          "anim": {
            "enable": false,
            "speed": 10,
            "size_min": 0.1,
            "sync": false
          }
        },
        "line_linked": {
          "enable": true,
          "distance": 150,
          "color": "#ffffff",
          "opacity": 0.4,
          "width": 1
        },
        "move": {
          "enable": true,
          "speed": 0.5,
          "direction": "none",
          "random": true,
          "straight": false,
          "out_mode": "out",
          "bounce": false,
          "attract": {
            "enable": false,
            "rotateX": 600,
            "rotateY": 1200
          }
        }
      },
      "interactivity": {
        "detect_on": "canvas",
        "events": {
          "onhover": {
            "enable": true,
            "mode": "repulse"
          },
          "onclick": {
            "enable": true,
            "mode": "push"
          },
          "resize": true
        },
        "modes": {
          "grab": {
            "distance": 400,
            "line_linked": {
              "opacity": 1
            }
          },
          "bubble": {
            "distance": 400,
            "size": 40,
            "duration": 2,
            "opacity": 8,
            "speed": 2
          },
          "repulse": {
            "distance": 200,
            "duration": 0.4
          },
          "push": {
            "particles_nb": 4
          },
          "remove": {
            "particles_nb": 2
          }
        }
      },
      "retina_detect": true
    });
  }
  function sidebarExpandClick() {
    this.closest('.jsSidebarBox').classList.toggle('expand');
    this.classList.toggle('expand');
    if(this.classList.contains('expand')) {
      this.textContent = 'Thu gọn';
    } else {
      this.textContent = 'Xem thêm';
    }
  }
  let sidebarExpandEls = document.querySelectorAll('.jsSidebarExpand');
  if (sidebarExpandEls.length > 0) {
    sidebarExpandEls.forEach(el => {
      el.addEventListener('click', sidebarExpandClick);
    });
  }

  let sidebarNavItemEls = document.querySelectorAll('#jsSidebarNav a');
  if (sidebarNavItemEls.length > 0) {
    sidebarNavItemEls.forEach(sidebarNavItemEl => {
      if(sidebarNavItemEl.pathname === location.pathname) {
        sidebarNavItemEl.classList.add('current');
      }else {
        sidebarNavItemEl.classList.remove('current');
      }
    });
  }

  let navItemEls = document.querySelectorAll('.jsNavItem');
  if (navItemEls.length > 0) {
    navItemEls.forEach(navItemEl => {
      if(navItemEl.pathname === location.pathname) {
        navItemEl.classList.add('current');
      }else {
        navItemEl.classList.remove('current');
      }
    });
  }
});